<template>
   <div>
  <div class="md:hidden p-6 btn-transparent min-h-screen flex justify-center items-center" style="background-color: #2D2E2C; ">
    <div class="w-full max-w-md">
      <flash-messages />
      <logo/>
       <br>  
                <div v-if="this.message" role="alert" class="mt-3 relative flex w-full p-3 text-sm text-white bg-black rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-5 w-5 mr-2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path></svg>
                {{this.message}}
              </div>
              
      <form class="mt-6 bg-transparent rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-1">
          <text-input v-model="form.email" :error="form.errors.email" style="color: white;" class="font-bold mt-2" type="email" autofocus autocapitalize="off" placeholder="Email"/>
          <text-input v-model="form.password" :error="form.errors.password" class="font-bold mt-2"  type="password" placeholder="Contraseña" />
        <div class="justify-center items-center">
          <br>   <br> 

          <loading-button :loading="form.processing" class="btn-indigoOrange" type="submit"  style="color: #FFFFFF; align-content: end;">ENTRAR</loading-button>
          <br>

        </div>
         <br> <br>   <br>
          <div class="bg-transparent flex items-center">
          <inertia-link class="text-white hover:underline" tabindex="-1" type="button" :href="route('password')">Olvide Contraseña</inertia-link>
          <inertia-link class="px-8 py-4 bg-white text-black rounded-xl ml-auto" style="margin-left: 5px;" type="button" :href="route('register')">Registrarme</inertia-link>
          </div>
           <br><br>
        </div>
      </form>
    </div>
  </div>
  <div class="hidden md:flex p-6 btn-transparent min-h-screen flex justify-center items-center" style="background-color: #2D2E2C; ">
    <div class="w-full max-w-md">
      <logo/>
      <br>  
                <div v-if="this.message" role="alert" class="mt-3 relative flex w-full p-3 text-sm text-white bg-black rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-5 w-5 mr-2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path></svg>
                {{this.message}}
              </div>
              
      <form class="mt-6 bg-transparent rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-1">
          <text-input v-model="form.email" :error="form.errors.email" style="color: white;" class="font-bold mt-2" type="email" autofocus autocapitalize="off" placeholder="Email"/>
          <text-input v-model="form.password" :error="form.errors.password" class="font-bold mt-2"  type="password" placeholder="Contraseña" />
          <br>  
                <div v-if="mensagge" role="alert" class="mt-3 relative flex w-full p-3 text-sm text-white bg-black rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-5 w-5 mr-2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path></svg>
                {{mensagge}}
              </div>
              <br>  
          <div class="flex justify-start items-center">
          <br>
          <loading-button :loading="form.processing" class="px-10 py-3 btn-indigoOrange" type="submit" >Ingresar</loading-button>
          <br> 
          <br> 
        </div>

          <br> 
          <br> 
          <br> 
          <div class="bg-transparent flex items-center">
          <inertia-link class="text-white hover:underline" tabindex="-1" type="button" :href="route('password')">Olvide Contraseña</inertia-link>
          <inertia-link class="px-8 py-3 bg-white text-black rounded-xl ml-auto" style="margin-left: 70px;" type="button" :href="route('register')">Registrarme</inertia-link>
          </div>
           <br><br>
        </div>
      </form>
    </div>
  </div>
 </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInputlogin'
import LoadingButton from '@/Shared/LoadingButtonOrange'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  metaInfo: { title: 'Login' },
  components: {
    LoadingButton,
    Logo,
    TextInput,
    FlashMessages,
  },
    props: {
    message: String,
  },
  data() {
    return {
      mensagge: '',
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
        codigo: '',
        token: '',
        
      }),
    }
  },
  methods: {
    login() {
      this.form.post(this.route('login.store'))
    },
    
  },
}
</script>
